import type { MarketConfig } from './types'

const fmt = new Intl.NumberFormat('ru-RU')

// Rough UZS→GEL scale so the mockups show plausible Georgian menu prices.
const UZS_PER_GEL = 2500

export const ge: MarketConfig = {
  code: 'ge',
  languages: [
    // The language code stays ka (ISO 639); the switcher shows GE, as visitors know it.
    { code: 'ka', label: 'ქართული', short: 'GE' },
    { code: 'ru', label: 'Русский', short: 'RU' },
    { code: 'en', label: 'English', short: 'EN' },
  ],
  defaultLanguage: 'ka',
  fallbackLanguage: 'en',
  phoneCountry: 'ge',
  contact: {
    phone: { display: '+995 511 28 77 93', href: 'tel:+995511287793' },
    telegram: { handle: '@samly_ge', href: 'https://t.me/samly_ge' },
    instagram: { handle: '@samly.ge', href: 'https://www.instagram.com/samly.ge/' },
    website: { display: 'samly.ge', href: 'https://samly.ge' },
  },
  pricing: {
    // 1 BRV converted at the CBU rate of 29.09.2026 (412 000 UZS ÷ 4 544.64 UZS/GEL = 90.66).
    unitValue: 91,
    showUnit: false,
    // 91 × 0.25 etc. are not whole lari, so show tetri.
    fractionDigits: 2,
    numberLocale: 'ru-RU',
  },
  mockVenueName: 'Supra',
  mockMoney: (uzs, opts) => {
    const gel = Math.round(uzs / UZS_PER_GEL)
    return opts?.short ? `${gel}` : fmt.format(gel)
  },
  // Printers work everywhere; the Uzbek payment and delivery partners do not.
  partnerLogos: ['esc_pos', 'star_prnt'],
  // No Yandex Eats and no Uzbek OFD in Georgia. TODO(ge): add RS.ge fiscalization once built.
  unavailable: ['yandex', 'e_kassa'],
}
